import React, { useEffect, useState } from "react";
import { Breadcrumb, Button, Radio, Select } from "antd";
import { DoubleRightOutlined } from "@ant-design/icons";
import { routes } from "../../../Routes";
import { InputBox } from "../../../components/CustomWidgets/InputBox";
import { useFormik } from "formik";
import SelectBox, {
  MultiSelectBox,
} from "../../../components/CustomWidgets/SelectBox";
import { Image } from "antd";
// import Group from "../../assets/Inventory/Group.svg";
import {
  InventoryProductRequest,
  fetchGS1,
  getInventoryEditResttriction,
  getUOM,
  updateGsProductRequest,
  uploadImage,
  uploadImageUrl,
} from "../../../API  Functions/InventoryFunctions";
import "../../../styles.css";
import UploadMediaonly from "../../../components/upload-imageonly";
import ProductrequestModal from "../../../modals/ProductrequestModal";
import { productRequestSchema } from "../../../components/validationSchema";
import Navbar from "../../../components/Navbar/Navbar";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { Link, useLocation, useNavigate } from "react-router-dom";
import LoadingSpinner from "../../../components/Loading";
import { checkPermission } from "../../../Utils/permissionHelper";
import { toast } from "react-toastify";
import { GetRetailerDetails } from "../../../API  Functions/ProfileFunctions";
import axiosInstance from "../../../AxiosInstance";
import { URLS } from "../../../API/API endpoints";
import AddPackage from "../../../assets/Inventory/AddPackage.svg";
import deleteicon from "../../../assets/Order/Delete.svg";
import { getProductGroups } from "../../../API  Functions/productGroupFunctions";

const ProductRequest = () => {
  const { t, i18n } = useTranslation();
  const user_id = useSelector((state) => state?.login?.user?.result?.user_id);
  const store_id = useSelector(
    (state) => state?.login?.user?.result?.company_id,
  );
  const location = useLocation();
  const userData = useSelector((state) => state?.login?.user?.result);
  const allStores = useSelector(
    (state) => state?.storeReducer?.selectedStore?.is_select_all_store,
  );
  const [UOM, setUOM] = useState([]);
  const [isUOMLoaded, setIsUOMLoaded] = useState(false);
  const [popup, setpopup] = useState(false);
  const [isnew, setisnew] = useState(false);
  const [isGS1, setisGS1] = useState(false);
  const [data, setdata] = useState([]);
  const [searchid, setsearchid] = useState("");
  const [base64Image, setBase64Images] = useState("");
  const [isFileValid, setIsFileValid] = useState(true);
  const [processing, setProcessing] = useState(false);
  const [allGroups, setAllGroups] = useState([]);
  const [vatTypes, setVatTypes] = useState([]);
  const [taxId, setTaxId] = useState("");
  const [isEtaEnable, setIsEtaEnable] = useState(null);
  const [costingMethod, setCostingMethod] = useState("");
    const [addPackagesContainer, ShowAddPackagesContainer] = useState(false);

   const [packagesArray, setPackagesArray] = useState([
      // { pack_price: "", pack_qty: "", secondary_barcode: "" },
    ]);
  const [existingProductPopup, setExistingProductPopup] = useState({
    visible: false,
    productId: null,
  });
  const [myginneProductPopup, setMyginneProductPopup] = useState({
    visible: false,
    productData: null,
  });

  const EGS_PREFIX = `EG-${taxId}-`;
  const navigate = useNavigate();

  useEffect(() => {
    console.log("isFileValid ", isFileValid);

    if (base64Image && isFileValid === false) {
      // getInventoryKPI();
      setBase64Images("");
      formik.setFieldValue("image_url", "");
    }
  }, [isFileValid, base64Image]);

  useEffect(() => {
    // fetchdetails();
    GetGroups();
    // GetVatTypes();
    CheckUserAcessForInventory();
  }, []);

  const CheckUserAcessForInventory = async () => {
    try {
      const res = await getInventoryEditResttriction(user_id);
      if (res?.result?.status_code == 200) {
        setIsEtaEnable(res?.result?.is_eta_enabled);
        setCostingMethod(res?.result?.costing_method);
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const GetVatTypes = async () => {
    const payload = {
      retailer_id: store_id,
      offset: 0,
      limit: 1000,
    };
    try {
      const res = await axiosInstance.post(URLS.GET_VAT_TYPES, payload);
      const res1 = res?.data;

      // console.log("res1---->", res1);

      if (res1?.result?.status_code === 200) {
        setVatTypes(res1?.result?.data?.filter((item) => item.is_active));
      } else {
        setVatTypes([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const fetchdetails = () => {
    GetRetailerDetails(user_id).then((result) => {
      if (result) {
        setTaxId(
          result?.retailer_details?.tax_card_number
            ? result?.retailer_details?.tax_card_number
            : null,
        );
      }
    });
  };

  const GetGroups = async () => {
    const payload = {
      lang: i18n.language === "ar" ? "ar_001" : "en_US",
      company_id: store_id,
      user_id: user_id,
      offset: 0,
      limit: 5000,
    };
    try {
      const res1 = await getProductGroups(payload);

      // console.log("res1---->", res1);

      if (res1?.result[0]?.status_code === 200) {
        setAllGroups(res1?.result[0]?.product_groups);
      } else {
        setAllGroups([]);
      }
    } catch (error) {
      console.error("Error fetching KPI data:", error);
      // setloading(false);
    } finally {
      // setloading(false);
    }
  };

  const get_UOM = async () => {
    const res = await getUOM();

    if (res?.result?.[0].status == "UOM List")
      setUOM(res?.result?.[0]?.uom_list);
    setIsUOMLoaded(true);
  };

  const checkSecondaryBarcode = async (
    product_id,
    secondaryBarcode,
    company_id,
  ) => {
    try {
      const body = {
        product_id: product_id, // if new product, send 0
        barcode: secondaryBarcode,
        company_id,
      };

      const res = await axiosInstance.post("/Store/2/CheckBarcode", body);

      return res?.data;
      // Example expected: "Barcode already exists" or "Barcode available"
    } catch (error) {
      console.error("Error checking barcode:", error);
      return "error";
    }
  };

  const Productrequest = async (val) => {
    if (!val?.name) return;

    if(packagesArray?.length > 0){

    const hasInvalidPrice = packagesArray.some((pkg) => {
          const costPrice =
            Number(formik.values.costprice || 0) * Number(pkg.pack_qty || 0);
          const salePrice = Number(pkg.pack_price || 0);
    
          return salePrice < costPrice;
        });
    
        if (hasInvalidPrice) {
          toast.error(t("Package sale price cannot be less than its cost price."));
          return;
        }
    }

    setProcessing(true);
    

    // ✅ HARD STOP for secondary barcode validation
    if (val?.secondaryBarcode?.trim()) {
      const result = await checkSecondaryBarcode(
        false,
        val.secondaryBarcode,
        store_id,
      );

      console.log("result====>", result);

      if (result?.result?.status_code !== 200) {
        toast.error(t(result?.result?.status));
        setProcessing(false);
        return false; // ⛔ NOTHING after this will run
      }
    }

    // ✅ EVERYTHING below runs ONLY if barcode is valid
    const costPrice = val?.costprice || 0;
    const salePrice = val?.saleprice || 0;
    const discountedPrice = val?.discounted_price || 0;

    const verifyEgsCodeAPI = async (egsCode, prod_id) => {
      try {
        const body = {
          product_id: prod_id || 0, // if new product, send 0
          egs_code: egsCode,
          company_id: store_id,
        };

        const res = await axiosInstance.post(URLS.VERIFY_EGS_CODE, body);

        if (res?.data?.result?.status_code == 200) {
          AddProductEGSCode(egsCode, prod_id);
        } else {
          toast.error(t("EGS code not verified"));
        }
      } catch (error) {
        console.error("Error checking barcode:", error);
        // return "error";
      }
    };

    const AddProductEGSCode = async (egsCode, prodId) => {
      try {
        const payload = {
          egs_code: egsCode,
          company_id: store_id,
          product_id: prodId, // <-- add product_id
        };
        const response = await axiosInstance.post(URLS.ADD_PRODUCT, payload);
      } catch (error) {
        console.error("Error checking barcode:", error);
        // return "error";
      }
    };
    let updatedVal = { ...val };

    if (updatedVal?.barcode?.trim() !== "" && !updatedVal?.is_gs1) {
      const fetchGtinResponse = await axiosInstance.post("/fetch_gs1_data", {
        gtin: updatedVal.barcode.trim(),
      });

      if (fetchGtinResponse.data?.result?.gtin) {
        const fetchedProduct = fetchGtinResponse.data.result;

        updatedVal.is_gs1 = true;

        if (!updatedVal.custom_name || updatedVal.custom_name.trim() === "") {
          updatedVal.custom_name = updatedVal.name;
        }

        updatedVal.name =
          i18n.language === "ar"
            ? fetchedProduct.product_description_arabic ||
              fetchedProduct.product_description_english
            : fetchedProduct.product_description_english ||
              fetchedProduct.product_description_english;
      }
    }

    const isValidEgsFilled = (egs) => {
      if (!egs) return false;
      if (egs === EGS_PREFIX) return false;
      return egs.length > EGS_PREFIX.length;
    };

    const response = await InventoryProductRequest(
      user_id,
      updatedVal,
      costPrice,
      salePrice,
      discountedPrice,
    );

    if (
      response?.result?.[0]?.status_code === 400 &&
      response?.result?.[0]?.status ===
        "Entered short code is already linked with another product."
    ) {
      toast.error(
        t(
          "Product Short Code Already Exists. Please Use a Different Short Code.",
        ),
      );
      setProcessing(false);
      return false;
    }

    if (response?.result?.[0]?.status_code === 200) {
      const productId = response.result[0].product_id;

      // const newEgs = val.egs_code;
      // const hasEgsNow = isValidEgsFilled(newEgs);

      //   // 👉 EGS entered now but wasn't there before
      //   if (hasEgsNow && (!userData?.is_sub_store && !userData?.is_warehouse)) {
      //        verifyEgsCodeAPI(newEgs, productId);
      //   }
      if(addPackagesContainer){
        await AddPackageToProduct(productId)
      }

      if (val?.secondaryBarcode?.trim()) {
        await handleAddSecondaryBarcode(productId, val.secondaryBarcode);
      }
      let uploadedImageUrl;
  if(base64Image != ''){
       uploadedImageUrl = await uploadImage(productId, base64Image);

  }
      if (uploadedImageUrl) {
        formik.setFieldValue("image_url", uploadedImageUrl);
        await uploadImageUrl(productId, uploadedImageUrl);
      }

      setisnew(true);
      setpopup(true);
      formik.resetForm();
      setBase64Images("");
      setProcessing(false);
      if (val.is_gs1) {
        navigate("/inventory/InventoryOnboard");
      }
      return true;
    } else {
      if (
        response?.result?.[0]?.status ===
          "The Product already exist with same barcode" &&
        response?.result?.[0]?.product_id
      ) {
        if (response?.result?.[0]?.is_on_my_inventory) {
          // Already in their inventory → show "view product" modal
          setExistingProductPopup({
            visible: true,
            productId: response?.result?.[0]?.product_id,
          });
        } else {
          // Exists in Myginne catalog but not in their inventory → show "add it?" modal
          setMyginneProductPopup({
            visible: true,
            productData: {
              ...val,
              // available_quantity: response?.result?.[0]?.available_quantity,
              prod_id: response?.result?.[0]?.product_id,
            },
          });
        }
      } else {
        toast.error(t(response?.result?.[0]?.status));
      }
      setProcessing(false);
      return false;
    }

    setProcessing(false);
    return false;
  };

  const AddPackageToProduct =async(id)=>{
     
    try {
      let payload = {
        product_id: Number(id),
        company_id: userData?.company_id,
        packages: packagesArray,
      };
      const response = await axiosInstance.post(
        URLS.UPDATE_PRODUCT_PACKAGE,
        payload,
      );
      setPackagesArray([])
      ShowAddPackagesContainer(false)
    
    } catch (error) {
      console.error("Error submitting data:", error);
    } finally {
    }
  }

  const handleAddFromMyginne = async () => {
    const values = myginneProductPopup.productData;
    if (!values) return;

    setMyginneProductPopup({ visible: false, productData: null });
    setProcessing(true);

    const barcode = values?.barcode || "";
    const totalQuantity = Number(values?.quantity) || 0;
    const product_name = values?.name || "";
    const cost_price = values?.costprice || 0;
    const sale_price = values?.saleprice || 0;
    const discounted_price = values?.discounted_price || 0;
    const company_id = store_id;
    const product_image = formik.values.image_url || "";
    const machine_barcode = false;
     const sanitizedPackages = packagesArray.map((pkg) => ({
      pack_qty: pkg.pack_qty ? Number(pkg.pack_qty) : 0,
      pack_price: pkg.pack_price ? Number(pkg.pack_price) : 0,
      secondary_barcode: pkg.secondary_barcode || "",
    }));
    const addPackagesContainer = false;
    const removeGroupIds = [];

    const payload = {
      barcode: barcode || "",
      quantity: totalQuantity,
      product_name2: values?.name?.trim() === "" ? "" : values?.name?.trim(),
      product_shortcut:
        values?.productShortcut?.trim() === ""
          ? ""
          : values?.productShortcut?.trim(),
      cost_price: cost_price ? Number(cost_price) : 0,
      sales_price: sale_price ? Number(sale_price) : 0,
      discounted_price:
        discounted_price > sale_price
          ? sale_price
            ? Number(sale_price)
            : 0
          : discounted_price
            ? Number(discounted_price)
            : 0,
      company_id,
      machine_barcode: machine_barcode || false,
      packages: [],
      is_update_package: false,
      
      product_id: values?.prod_id,
      add_group_ids:
        values?.groups && !userData?.is_sub_store && !userData?.is_warehouse
          ? values?.groups
          : [],
      remove_group_ids: [],
    };

    try {
      const response = await axiosInstance.post(URLS.ADD_PRODUCT, payload);

      if (response?.data?.result?.status_code === 200) {
        const productId = response?.data?.result?.product_id;

        if (values?.secondaryBarcode?.trim()) {
          await handleAddSecondaryBarcode(productId, values.secondaryBarcode);
        }

        // const uploadedImageUrl = await uploadImage(productId, base64Image);
        // if (uploadedImageUrl) {
        //   await uploadImageUrl(productId, uploadedImageUrl);
        // }

        setisnew(true);
        setpopup(true);
        formik.resetForm();
        setBase64Images("");
         setPackagesArray([]);
      } else {
        toast.error(t(response?.data?.result?.status));
      }
    } catch (error) {
      console.error("Error adding product from Myginne:", error);
      toast.error(t("Something went wrong. Please try again."));
    } finally {
      setProcessing(false);
    }
  };

  const handleAddSecondaryBarcode = async (id, code) => {
    const payload = {
      company_id: store_id,
      product_id: id,
      barcode_data: [
        // NEW BARCODE
        {
          id: false,
          is_delete: false,
          barcode: code,
        },
      ],
    };
    try {
      const response = await axiosInstance.post(
        URLS.ADD_SECONDARY_BARCODE,
        payload,
      );

      if (response?.data?.result?.status_code != 200) {
        toast.error(response?.data?.result?.status);
      }
    } catch (error) {
      console.error("Error submitting data:", error);
    }
  };

  useEffect(() => {
    UOM?.length == 0 && get_UOM();
  }, []);

  const { fetchedProduct } = location.state || {};

  const formik = useFormik({
    initialValues: {
      name: fetchedProduct?.product_description_english || "",
      custom_name: "",
      // egs_code:"",
      barcode: fetchedProduct?.gtin || "",
      product_uom: "",
      costprice: "",
      saleprice: "",
      discounted_price: "",
      quantity: "",
      image_url: "",
      product_code: "",
      productShortcut: "",
      secondaryBarcode: "",
      groups: [],
      is_gs1: fetchedProduct?.gtin ? true : false,
      isinclusive: null,
      tax_id: null,
      costingMethod: costingMethod,
    },
    enableReinitialize: true,
    validationSchema: productRequestSchema,
  });
  console.log("errrrr reqqq==>", formik.errors);

  useEffect(() => {
    if (isUOMLoaded && fetchedProduct?.gtin) {
      const uomId = UOM.find((uom) => uom.uom_name === "Units")?.uom_id;
      if (uomId) {
        formik.setFieldValue("product_uom", uomId);
      }
    }
  }, [isUOMLoaded, fetchedProduct, UOM]);

  const validate = (values) => {
    const errors = {};

    if (!values.product_uom) {
      errors.product_uom = "Product UOM is required";
    }

    const isLoose =
      values.product_uom &&
      UOM.find(
        (uom) =>
          (uom.uom_name === "KG" ||
            uom.uom_name === "Kg" ||
            uom.uom_name === "Liter" ||
            uom.uom_name === "Meter") &&
          uom.uom_id === values.product_uom,
      );

    if (
      isLoose &&
      values.product_code != "" &&
      values.product_code?.length < 7
    ) {
      errors.product_code = "Product Code should have at least 7 digits";
    }

    const selectedUOM = UOM.find((uom) => uom.uom_id === values.product_uom);

    // ✅ AVCO validation added here
    if (
      costingMethod === "AVCO" &&
      (!values.costprice || Number(values.costprice) <= 0)
    ) {
      errors.costprice = "Cost Price must be greater than 0 for AVCO";
    }

    if (
      values.costprice &&
      values.saleprice &&
      Number(values.costprice) > Number(values.saleprice)
    ) {
      errors.costprice = t("Cost Price cannot be greater than Sale Price");
    }

    if (
      values.discounted_price &&
      values.saleprice &&
      values.discounted_price > values.saleprice
    ) {
      errors.discounted_price = t(
        "Discounted Price cannot be greater than Sale Price",
      );
    }

    return errors;
  };


   const handleAddPackage = () => {
    setPackagesArray((prev) => [
      ...prev,
      { pack_price: "", pack_qty: "", secondary_barcode: "" },
    ]);
  };

  const handleDeletePackage = (index) => {
    const updated = packagesArray.filter((_, i) => i !== index);
    if (updated.length === 0) {
      setPackagesArray([]);
      ShowAddPackagesContainer(false);
    } else {
      setPackagesArray(updated);
    }
  };

  const handleChange = (index, field, value) => {
    const updated = [...packagesArray];
    updated[index][field] = value;
    setPackagesArray(updated);
  };
console.log("formik.values.product_uom==>",formik.values);

  return (
    <>
      {processing && <LoadingSpinner />}
      <div>
        <Navbar heading="product_request" />
      </div>
      <form onSubmit={formik.handleSubmit}>
        <div className="h-auto pb-6 bg-[#F6F7F9] min-h-[50vh] ">
          <div className="flex flex-col">
            <div className="me-3 ms-3 font-extrabold">
              <Breadcrumb
                separator={<DoubleRightOutlined />}
                items={[
                  {
                    title: (
                      <Link to={routes.inventory.inventoryOnboard}>
                        {t("Add Product")}
                      </Link>
                    ),
                    key: "Add Product",
                  },
                  { title: t("product_request") },
                ]}
                className="relative mt-3 font-semibold"
              />
              {/* <Breadcrumb
                separator={<DoubleRightOutlined />}
                items={[
                  {
                    title: t("inventory"),
                    href: routes.inventory.root,
                  },
                  { title: t("product_request") },
                ]}
                className="relative top-3"
              /> */}
            </div>
            <div></div>
            <div className="mx-2 h-10 bg-[#C9ECF7] rounded-t-xl mt-6 flex items-center">
              <p className=" ms-4">{t("product_details")}</p>
            </div>

            <div className="flex flex-col-reverse md:flex-row flex-1  bg-white mx-2 border rounded-b-xl">
              <div className="m-2 w-[95%] md:w-8/12 p-4 ">
                <span className=" block leading-[0px]">
                  {/* <label>{t("product_name")}</label> */}
                  <div className="">
                    <InputBox
                      name="name"
                      reqiured
                      label={t("product_name")}
                      placeholder={t("enter_product_name")}
                      // onChange={formik.handleChange}
                      onChange={(event) => {
                        const { value } = event.target;

                        // Allow only alphanumeric characters and spaces
                        // if (/^[a-zA-Z0-9\s]*$/.test(value) || value === "") {
                        formik.setFieldValue("name", value);
                        // }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.name}
                      error={formik.errors.name}
                      readOnly={
                        fetchedProduct?.gtin &&
                        fetchedProduct?.product_description_english
                      }
                      touched={formik.touched.name}
                      maxLength={150}
                    />
                  </div>
                </span>
                {!userData?.is_sub_store && !userData?.is_warehouse && (
                  <>
                    <div className="flex">
                      <span className=" block leading-[0px] w-6/12 me-3">
                        <InputBox
                          name="custom_name"
                          label={t("Custom Product Name")}
                          placeholder={t("Enter Custom Product Name")}
                          onChange={(event) => {
                            const { value } = event.target;

                            formik.setFieldValue("custom_name", value);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.custom_name}
                          // maxLength={150}
                        />
                      </span>
                      <span className="block leading-[0px] w-6/12">
                        <InputBox
                          label={t("Product Short Code")}
                          className={`${
                            formik.errors.productShortcut ? "border-red" : ""
                          }`}
                          name="productShortcut"
                          placeholder={t("Enter Product Short Code")}
                          onChange={(e) => {
                            const val = e.target.value;
                            formik.setFieldValue("productShortcut", val);
                          }}
                          onBlur={formik.handleBlur}
                          value={formik.values.productShortcut}
                          error={formik.errors.productShortcut}
                          touched={formik.errors.productShortcut}
                          readOnly={
                            userData?.is_sub_store || userData?.is_warehouse
                          }
                          maxLength={10}
                          onKeyPress={(e) => {
                            if (!/[0-9]/.test(e.key)) {
                              e.preventDefault();
                            }
                          }}
                        />
                      </span>
                    </div>
                  </>
                )}

                <div className="flex items-end -mt-2">
                  <span
                    className={`block leading-[0px] w-6/12  mt-2 ${
                      !userData?.is_sub_store && !userData?.is_warehouse
                        ? "w-6/12 me-3"
                        : "w-full"
                    }`}
                  >
                    {/* <label>{t("barcode")}</label> */}
                    <InputBox
                      type="text"
                      name="barcode"
                      label={t("Barcode")}
                      placeholder={t("Enter Barcode")}
                      maxLength={14}
                      // onChange={formik.handleChange}
                      onChange={(event) => {
                        const { value } = event.target;

                        // Allow only numeric input
                        // if (/^\d*$/.test(value)) { // This regex allows only digits
                        //   formik.setFieldValue("barcode", value);
                        // }
                        if (/^\d*$/.test(value)) {
                          // This regex allows only digits
                          formik.setFieldValue("barcode", value);
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.barcode}
                      error={formik.errors.barcode}
                      touched={formik.touched.barcode}
                      readOnly={!!fetchedProduct?.gtin}
                    />
                  </span>
                  {!userData?.is_sub_store && !userData?.is_warehouse && (
                    <span className="block leading-[0px] w-6/12">
                      <InputBox
                        label={t("Secondary Barcode")}
                        type="number"
                        className={`${
                          formik.errors.secondaryBarcode ? "border-red" : ""
                        }`}
                        name="secondaryBarcode"
                        placeholder={t("Enter Secondary Barcode")}
                        onChange={(e) => {
                          const val = e.target.value;
                          if (/^\d{0,18}$/.test(val)) {
                            formik.setFieldValue("secondaryBarcode", val);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.secondaryBarcode}
                        error={formik.errors.secondaryBarcode}
                        touched={formik.errors.secondaryBarcode}
                        maxLength={14}
                      />
                    </span>
                  )}
                </div>
                {/* {isEtaEnable == true && <>
                  {!userData?.is_sub_store && !userData?.is_warehouse && (
                  <span className="block leading-[0px] w-full">
                    <InputBox
                      name="egs_code"
                      label={t("EGS Code")}
                      placeholder={t("Enter EGS Code")}
                      value={
                        formik.values.egs_code?.startsWith(EGS_PREFIX)
                          ? formik.values.egs_code
                          : EGS_PREFIX
                      }
                      readOnly={userData?.is_sub_store}
                      maxLength={30}
                      onChange={(event) => {
                        let value = event.target.value;

                        // If user tries to delete prefix, restore it
                        if (!value.startsWith(EGS_PREFIX)) {
                          value = EGS_PREFIX;
                        }

                        // Allow only digits after prefix
                        const suffix = value
                          .slice(EGS_PREFIX.length)
                          .replace(/[^0-9]/g, "");

                        formik.setFieldValue("egs_code", EGS_PREFIX + suffix);
                      }}
                      onKeyDown={(e) => {
                        const cursorPosition = e.target.selectionStart;

                        // Prevent backspace/delete inside prefix
                        if (
                          (e.key === "Backspace" || e.key === "Delete") &&
                          cursorPosition <= EGS_PREFIX.length
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onBlur={formik.handleBlur}
                    />
                  </span>
                )}
                 <div className="mt-3 flex w-full justify-between">
                     <div className="w-1/2 me-7">
                                  <h3 className="text-sm font-normal mb-2 text-gray-600">
                                    {t("Tax")}
                                  </h3>
                                  <Select
                                    style={{ width: "100%" }}
                                    placeholder={t("Select Tax")}
                                    className="h-10"
                                    value={formik.values?.taxId}
                                    onChange={(value) => formik.setFieldValue("taxId", value)}
                                    getPopupContainer={(triggerNode) => triggerNode.parentElement}
                                    options={vatTypes.map((vat) => ({
                                     label: `${vat.tax_name} (${vat.tax_rate_percent}%)`,
                                      value: vat.id,
                                    }))}
                                  />
                                </div>
                                  <div className="w-1/2 flex flex-col">
              <h3 className="text-sm font-normal mb-2 text-gray-600">
                {t("Tax Type")}
              </h3>

              <Radio.Group
                value={formik.values?.isinclusive == true ? 'inclusive' : formik.values?.isinclusive == false  ? 'exclusive' : null}
                onChange={(e) => formik.setFieldValue("isinclusive", e.target.value == "inclusive" ? true : false)}
              >
                <Radio value="exclusive">{t("Exclusive")}</Radio>
                <Radio value="inclusive">{t("Inclusive")}</Radio>
              </Radio.Group>
            </div>
                  </div></>} */}

                {!userData?.is_sub_store &&
                  !userData?.is_warehouse &&
                  !processing && (
                    <div className="mt-3">
                      <MultiSelectBox
                        label={t("Product Groups")}
                        name="groups"
                        onChange={(event) => {
                          formik.setFieldValue("groups", event.target.value);
                        }}
                        placeholder={t("Select Groups")}
                        options={[
                          ...allGroups?.map((item) => ({
                            value: item?.id,
                            label:
                              i18n.language == "ar"
                                ? item?.name_ar
                                : item?.name,
                          })),
                        ]}
                      />
                    </div>
                  )}
                <div className="flex flex-row gap-5">
                  <span className="w-full leading-[0px]">
                    <InputBox
                      type="text"
                      name="quantity"
                      reqiured
                      label={t("quantity")}
                      placeholder={t("enter_quantity")}
                      onChange={(event) => {
                        const { value } = event.target;

                        const selectedUom = UOM.find(
                          (uom) =>
                            uom.uom_name === "Units" &&
                            uom.uom_id === formik.values.product_uom,
                        );
                        // {console.log("KKKK",selectedUom?.name)}

                        // Allow only valid input based on UOM
                        if (
                          (selectedUom?.uom_name !== "Units" &&
                            /^\d*\.?\d{0,2}$/.test(value)) || // Allow decimals for non-units
                          (selectedUom?.uom_name === "Units" &&
                            /^\d{0,6}$/.test(value)) // Only whole numbers for units
                        ) {
                          // Prevent multiple hyphens and other invalid characters
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("quantity", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.quantity}
                      error={formik.errors.name}
                      touched={formik.touched.name}
                    />
                  </span>
                  <span className="w-full leading-[0px] flex flex-col">
                    {/* <label className="pb-2">{t("product_uom")}</label> */}
                    <SelectBox
                      name="product_uom"
                      reqiured
                      label={t("product_uom")}
                      defaultValue=""
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.product_uom}
                      options={[
                        { value: "", label: t("select"), disabled: true },
                        ...UOM?.map((item) => ({
                          value: item.uom_id,
                          label: t(item.uom_name),
                        })),
                      ]}
                      error={formik.errors.product_uom}
                      touched={formik.touched.product_uom}
                      disabled={!!fetchedProduct?.gtin}
                    />
                  </span>
                </div>

                {formik.values.product_uom &&
                  UOM.find(
                    (uom) =>
                      (uom.uom_name === "KG" ||
                        uom.uom_name === "Kg" ||
                        uom.uom_name === "Liter" ||
                        uom.uom_name == "Meter") &&
                      uom.uom_id === formik.values.product_uom,
                  ) && (
                    <div className=" w-full leading-[0px]">
                      {/* <label>{t("Product Code")}</label> */}
                      <InputBox
                        label={t("Weighing Scale Product Code")}
                        type="number"
                        name="product_code"
                        placeholder={t("Enter Product Code")}
                        // onChange={formik.handleChange}
                        onChange={(event) => {
                          const { value } = event.target;

                          // Allow only numbers and restrict to 7 digits
                          if (/^\d{0,7}$/.test(value)) {
                            formik.setFieldValue("product_code", value);
                          }
                        }}
                        onBlur={formik.handleBlur}
                        value={formik.values.product_code}
                        error={formik.errors.product_code}
                        touched={formik.touched.product_code}
                      />
                    </div>
                  )}
                <div className="flex flex-row">
                  <span className=" leading-[0px] w-6/12 me-3">
                    {/* <label>{t("cost_price")}</label> */}
                    <InputBox
                      type="text"
                      label={t("cost_price")}
                      name="costprice"
                      reqiured={costingMethod === "AVCO"}
                      placeholder={t("enter_cost_price")}
                      onChange={(event) => {
                        const { value } = event.target;
                        if (
                          value === "" ||
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value)
                        ) {
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("costprice", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.costprice}
                      error={formik.errors.costprice}
                      touched={formik.touched.costprice}
                    />
                  </span>
                  <span className="leading-[0px] w-6/12">
                    {/* <label>{t("sale_price")}</label> */}
                    <InputBox
                      type="text"
                      label={t("sale_price")}
                      reqiured={costingMethod === "AVCO"}
                      name="saleprice"
                      placeholder={t("enter_sale_price")}
                      onChange={(event) => {
                        const { value } = event.target;

                        if (
                          value === "" || // Allow empty input
                          /^(0|[1-9]\d{0,6})(\.\d{0,2})?$/.test(value) // Allow numbers with up to 6 digits before decimal and 2 after
                        ) {
                          // Prevent multiple hyphens and other invalid characters
                          if (!/[^\d.]/.test(value) && !/(--)/.test(value)) {
                            formik.setFieldValue("saleprice", value);
                          }
                        }
                      }}
                      onBlur={formik.handleBlur}
                      value={formik.values.saleprice}
                      error={formik.errors.saleprice}
                      touched={formik.touched.saleprice}
                    />
                  </span>
                </div>
  <>
              {!addPackagesContainer &&
                !userData?.is_sub_store && !userData?.is_warehouse && !allStores &&
                  formik.values.product_uom === 1 && (
                    <div className="flex cursor-pointer justify-end mt-1 me-4 md:me-0">
                      <span
                        onClick={() => {
                          if (!addPackagesContainer) {
                            setPackagesArray((prev) => [
                              ...prev,
                              {
                                pack_price: "",
                                pack_qty: "",
                                secondary_barcode: "",
                              },
                            ]);
                          }
                          ShowAddPackagesContainer(true);
                        }}
                        className="font-medium text-base text-[#7EC242]"
                      >
                        {t("Add Package")}
                      </span>
                    </div>
                  )}
                {addPackagesContainer && (
                  <div className="bg-[#F5F5F5] rounded-lg p-5 mt-3">
                    <div className="mb-3 flex flex-col gap-2 sm:flex-row sm:items-center sm:justify-between">
                      <span className="font-medium">
                        {t("Package Details")}
                      </span>
                      {!userData?.is_sub_store &&
                        !userData?.is_warehouse &&
                        !allStores && (
                          <div
                            onClick={handleAddPackage}
                            className="flex rounded-md py-2 px-3 bg-[#7EC242] text-white font-normal text-sm cursor-pointer items-center"
                          >
                            <img
                              className="me-2 w-4 h-4"
                              src={AddPackage}
                              alt="add"
                            // onClick={() => handleDeletePackage(index)}
                            />
                            {t("Add New Pack")}
                          </div>
                        )}
                    </div>

                    {packagesArray.map((pack, index) => (
                      <div
                        key={index}
  className="mb-5 mt-1 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-[1fr_1fr_1fr_1fr_40px] gap-4 items-center"
                      >
                        {/* Barcode: Allow only integers (no decimal) */}
                        <span className="w-full">
                          <InputBox
                            label={t("Barcode")}
                            placeholder={t("Enter Barcode")}
                            backgroundColor={"bg-white"}
                            readOnly={
                              userData?.is_sub_store ||
                              userData?.is_warehouse ||
                              allStores
                            }
                            value={pack.secondary_barcode}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (/^\d{0,18}$/.test(val)) {
                                handleChange(index, "secondary_barcode", val);
                              }
                            }}
                          />
                        </span>
                        {/* Pack Quantity: Allow numbers with up to 2 decimals */}
                        <span className="w-full">
                          <InputBox
                            label={t("Pack Quantity")}
                            placeholder={t("Enter Pack Quantity")}
                            backgroundColor={"bg-white"}
                            readOnly={
                              userData?.is_sub_store ||
                              userData?.is_warehouse ||
                              allStores
                            }
                            value={pack.pack_qty}
                            onChange={(e) => {
                              const val = e.target.value;
                              if (/^\d{0,3}$/.test(val) || val === "") {
                                handleChange(index, "pack_qty", val);
                              }
                            }}
                          />
                        </span>

                        {/* Sale Price: Allow numbers with up to 2 decimals */}
                        <span className="w-full">
                          <InputBox
                            label={t("Sale Price")}
                            placeholder={t("Enter Sale Price")}
                            backgroundColor={"bg-white"}
                            readOnly={
                              userData?.is_sub_store ||
                              userData?.is_warehouse ||
                              allStores
                            }
                            value={pack.pack_price}
                            onChange={(e) => {
                              const val = e.target.value;
                              const regex = /^\d{0,7}(\.\d{0,2})?$/;

                              if (regex.test(val) || val === "") {
                                handleChange(index, "pack_price", val);
                              }
                            }}
                          />
                        </span>
                        <span className="w-full">
                          <InputBox
                            backgroundColor={"bg-[#EBEBEB]"}
                            label={t("Cost Price")}
                            placeholder={t("")}
                            value={formik.values.costprice * pack.pack_qty}
                            readOnly={true}
                          // onChange={(e) => {
                          //   const val = e.target.value;
                          //   const regex = /^\d{0,7}(\.\d{0,2})?$/;
                          //   if (regex.test(val) || val === "") {
                          //     handleChange(index, "pack_price", val);
                          //   }
                          // }}
                          />
                        </span>

                        {!userData?.is_sub_store &&
                          !userData?.is_warehouse &&
                          !allStores && (
                            <img
                              className="mx-1 mt-1 h-5 w-5 cursor-pointer sm:mt-2 lg:mt-10"
                              src={deleteicon}
                              alt="deleteicon"
                              onClick={() => handleDeletePackage(index)}
                            />
                          )}
                      </div>
                    ))}
                    {packagesArray?.length > 0 &&
                      !userData?.is_sub_store &&
                      !userData?.is_warehouse &&
                      !allStores && (
                        <span className="mt-3 text-sm">
                          {t(
                            "Note: Removing a pack here will not remove it from the Cashier system.",
                          )}
                        </span>
                      )}
                  </div>
                )}
              </>
                <button
                  type="submit"
                  onClick={async () => {
                    if (!checkPermission("/inventory")) {
                      return;
                    }
                    const errors = validate(formik.values);
                    formik.setErrors(errors);
                    console.log("errorserrorserrors", errors);

                    if (Object.keys(errors).length === 0) {
                      const costPrice = formik.values.costprice || 0;
                      const salePrice = formik.values.saleprice || 0;
                      console.log("sahcdshvrevje1113e4343", errors);
                      const check = await Productrequest({
                        ...formik.values,
                        costprice: costPrice,
                        saleprice: salePrice,
                      });

                      if (check) {
                        formik.resetForm();
                      }
                    }
                  }}
                  disabled={
                    !formik.values.name ||
                    !formik.values.product_uom ||
                    !formik.values.quantity ||
                    // ✅ AVCO condition
                    (costingMethod === "AVCO" &&
                      (!formik.values.costprice ||
                        Number(formik.values.costprice) <= 0)) ||
                    (formik.values.costprice && !formik.values.saleprice) ||
                    (!formik.values.costprice && formik.values.saleprice) ||
                    Number(formik.values.saleprice) <
                      Number(formik.values.costprice) ||
                    isFileValid === false ||
                    processing
                  }
                  className={`w-48 h-10 mt-8 bg-primaryBlue text-white text-sm font-semibold rounded-lg flex items-center justify-center gap-2 disabled:opacity-40`}
                >
                  <span>{t("save_add")}</span>
                </button>
              </div>
              <div className="m-2 p-2 md:p-4 ">
                <span
                  className={`flex  flex-col w-80 md:w-72 h-36 md:h-80 border rounded-xl relative top-4 ${
                    i18n.language == "en"
                      ? "left-0 "
                      : "right-0 "
                  } justify-center items-center `}
                >
                  {formik?.values?.image_url ? (
                    <img
                      src={formik.values.image_url}
                      height={100}
                      width={100}
                      alt="prod"
                      style={{
                        minWidth: "17rem",
                        maxWidth: "18rem",
                        maxHeight: "13rem",
                        minHeight: "12rem",
                      }}
                    />
                  ) : base64Image ? (
                    <img
                      src={base64Image}
                      height={100}
                      width={100}
                      alt="Uploaded"
                      style={{
                        minWidth: "17rem",
                        maxWidth: "18rem",
                        maxHeight: "13rem",
                        minHeight: "12rem",
                      }}
                    />
                  ) : (
                    <svg
                      className=" float-left h-10 w-12 text-gray-300"
                      viewBox="0 0 24 24"
                      fill="currentColor"
                      aria-hidden="true"
                    >
                      <path
                        fill-rule="evenodd"
                        d="M1.5 6a2.25 2.25 0 012.25-2.25h16.5A2.25 2.25 0 0122.5 6v12a2.25 2.25 0 01-2.25 2.25H3.75A2.25 2.25 0 011.5 18V6zM3 16.06V18c0 .414.336.75.75.75h16.5A.75.75 0 0021 18v-1.94l-2.69-2.689a1.5 1.5 0 00-2.12 0l-.88.879.97.97a.75.75 0 11-1.06 1.06l-5.16-5.159a1.5 1.5 0 00-2.12 0L3 16.061zm10.125-7.81a1.125 1.125 0 112.25 0 1.125 1.125 0 01-2.25 0z"
                      />
                    </svg>
                  )}
                  <span className="cursor-pointer">
                    <UploadMediaonly
                      foldername={"store_image"}
                      onfileAdd={"Productrequest"}
                      setBase64Images={setBase64Images}
                      urlgenerated={(val) =>
                        formik.setFieldValue("image_url", val?.url)
                      }
                      imageurl={
                        formik?.values?.image_url == undefined
                          ? ""
                          : formik?.values?.image_url
                      }
                      setIsFileValid={setIsFileValid}
                      setImageLoading={()=>{}}
                    />
                  </span>
                </span>
              </div>
            </div>
          </div>
        </div>
      </form>
      {popup && (
        <ProductrequestModal onClose={() => setpopup(false)} isnew={isnew} />
      )}
      {myginneProductPopup.visible && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: 12,
              padding: "2rem",
              maxWidth: 420,
              width: "90%",
              textAlign: "center",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            }}
          >
            <div
              style={{
                width: 56,
                height: 56,
                borderRadius: "50%",
                background: "#eff6ff",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                margin: "0 auto 16px",
                fontSize: 26,
              }}
            >
              🛒
            </div>
            <h2
              style={{
                fontWeight: 600,
                fontSize: 18,
                marginBottom: 8,
                color: "#111827",
              }}
            >
              {t("Product Found in myGINNE")}
            </h2>
            <p
              style={{
                color: "#6b7280",
                fontSize: 14,
                marginBottom: 24,
                lineHeight: 1.6,
              }}
            >
              {t(
                "This product already exists in Myginne's catalog but hasn't been added to your inventory yet. Would you like to add it?",
              )}
            </p>
            <div
              style={{
                display: "flex",
                gap: 12,
                justifyContent: "space-between",
                marginInline: 10,
              }}
            >
              <button
                onClick={() =>
                  setMyginneProductPopup({ visible: false, productData: null })
                }
                style={{
                  padding: "10px 24px",
                  borderRadius: 8,
                  border: "1px solid #d1d5db",
                  background: "white",
                  cursor: "pointer",
                  fontWeight: 500,
                  color: "#374151",
                }}
              >
                {t("Cancel")}
              </button>
              <button
                onClick={handleAddFromMyginne}
                style={{
                  padding: "10px 24px",
                  borderRadius: 8,
                  border: "none",
                  background: "#1b4597",
                  color: "white",
                  cursor: "pointer",
                  fontWeight: 500,
                }}
              >
                {t("Yes, Add to Inventory")}
              </button>
            </div>
          </div>
        </div>
      )}
      {existingProductPopup.visible && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
            background: "rgba(0,0,0,0.45)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <div
            style={{
              background: "white",
              borderRadius: 12,
              padding: "2rem",
              maxWidth: 420,
              width: "90%",
              textAlign: "center",
              boxShadow: "0 8px 32px rgba(0,0,0,0.18)",
            }}
          >
            <div style={{ fontSize: 48, marginBottom: 12 }}>📦</div>
            <h2 style={{ fontWeight: 600, fontSize: 18, marginBottom: 8 }}>
              {t("Product Already Exists")}
            </h2>
            <p style={{ color: "#6b7280", fontSize: 14, marginBottom: 24 }}>
              {t(
                "A product with this barcode already exists in your inventory.",
              )}
            </p>
            <div
              style={{
                display: "flex",
                gap: 12,
                justifyContent: "space-between",
                marginInline: 10,
              }}
            >
              <button
                onClick={() =>
                  setExistingProductPopup({ visible: false, productId: null })
                }
                style={{
                  padding: "10px 24px",
                  borderRadius: 8,
                  border: "1px solid #d1d5db",
                  background: "white",
                  cursor: "pointer",
                  fontWeight: 500,
                }}
              >
                {t("Close")}
              </button>
              <button
                onClick={() => {
                  setExistingProductPopup({ visible: false, productId: null });
                  navigate(
                    `/productdetails?Id=${existingProductPopup.productId}`,
                  );
                }}
                style={{
                  padding: "10px 24px",
                  borderRadius: 8,
                  border: "none",
                  background: "#1b4597",
                  color: "white",
                  cursor: "pointer",
                  fontWeight: 500,
                }}
              >
                {t("View Product")}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default ProductRequest;
